import { ISelectOption } from '../interfaces';
import { AccessRules } from '../types/entities';

export const DEFAULT_PROJECT_SETTINGS = 'default_project_settings';
export const FAVORITE_QUICK_ENTITIES = 'favorite_quick_entities';

export enum predefinedTemplates {
  MAP_LAYER = 'mapLayer',
  MAP_OBJECT = 'mapObject',
}

export enum mapEntityParams {
  NAME = 'Название',
  GEOMETRY = 'Координаты',
  DATE = 'Дата',
  OPACITY = 'Прозрачность',
  DESCRIPTION = 'Описание',
  COLOR = 'Цвет',
  TYPE = 'Тип объекта',
  STATUS = 'Статус',
  MEDIA = 'Медиа',
  SOURCE = 'Источник',
  RELIABILITY = 'Общая достоверность',
  RELEVANCE = 'Общая актуальность',
}

export enum MapEntityStatuses {
  REVEALED = 'Вскрыто',
  CONFIRMED = 'Подтверждено',
  SENT_TO_DEFEAT = 'Передано на поражение',
  ACCEPTED_TO_DEFEAT = 'Принято до поражения',
  SUPRESSED = 'Подавлено',
  MISSED = 'Промах',
  DEFEATED = 'Поражено',
  DESTROYED = 'Уничтожено',
  BANNED = 'Запрет действий',
  UNKNOWN = 'Неизвестно',
}

export enum MapEntitySources {
  VR = 'ВР Войсковая разведка',
  AGR = 'АГР Агентурная разведка',
  RER = 'РЭР Радиоэлектронная разведка',
  VZR = 'ВзР Воздушная разведка',
  KSR = 'КсР Космическая разведка',
  KSH = 'КШ Компьютерный шпионаж',
  SPR = 'СпР Специальная разведка',
}

export const MAP_ENTITY_PARAM_VALUES = Object.values(mapEntityParams);

export const MAP_ENTITY_FILTERABLE_PARAMS = [
  mapEntityParams.STATUS,
  mapEntityParams.DATE,
  mapEntityParams.TYPE,
  mapEntityParams.RELEVANCE,
];

export const enum AccessRuleCode {
  RESTRICT = 0,
  READONLY = 2,
  READWRITE = 15,
}

export const DUMMY_ACCESS_RULES: AccessRules = {
  accessType: AccessRuleCode.READWRITE,
  isUserBranchAdmin: true,
  isPersonalSpace: true,
};

export const accessRuleOptions: ISelectOption[] = [
  {
    label: verboseAccessRule(AccessRuleCode.RESTRICT),
    value: AccessRuleCode.RESTRICT,
  },
  {
    label: verboseAccessRule(AccessRuleCode.READONLY),
    value: AccessRuleCode.READONLY,
  },
  {
    label: verboseAccessRule(AccessRuleCode.READWRITE),
    value: AccessRuleCode.READWRITE,
  },
];

export function verboseAccessRule(rule: AccessRuleCode) {
  switch (rule) {
    case AccessRuleCode.RESTRICT:
      return 'Ограничить доступ';
    case AccessRuleCode.READONLY:
      return 'Только чтение';
    case AccessRuleCode.READWRITE:
      return 'Чтение и запись';
  }
}

export const HIT_STATUS = 'Поражено';
export const NOT_RELEVANT = 'Неактуально';
